import { FunctionComponent } from 'react'
import { useToggle } from 'react-use'
import KolExportButton from '@/components/kol/export/kol-export-button'
import KolExportModal from '@/components/kol/export/kol-export-modal'
import useIsPublicDetailPage from '@/hooks/use-is-public-detail-page'
import { usePermissions } from '@/hooks/use-permissions'

interface KolExportProps {
  isDisabled: boolean
  kolId: string
  kolDcIdHashed?: string
}

const KolExport: FunctionComponent<KolExportProps> = ({
  isDisabled,
  kolId,
  kolDcIdHashed,
}) => {
  const isPublicKolDetailPage = useIsPublicDetailPage()

  const [modalOpen, toggleExportModal] = useToggle(false)

  const { withKolPermission } = usePermissions()

  if (withKolPermission || isPublicKolDetailPage) {
    return null
  }

  return (
    <div>
      <KolExportButton
        isDisabled={isDisabled}
        kolDcIdHashed={kolDcIdHashed}
        kolId={kolId}
        onClick={toggleExportModal}
      />
      <KolExportModal
        kolDcIdHashed={kolDcIdHashed}
        kolId={kolId}
        open={modalOpen}
        onClose={toggleExportModal}
      />
    </div>
  )
}

export default KolExport
